import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App /> // 👈 Removed StrictMode for stability during testing
);

reportWebVitals();
serviceWorkerRegistration.register();